const ABSENCE_REASON_MESSAGES = {
  NOT_EXIST_BUSINESS: 'El almacén no está registrado en Tienda Virtual.',
  ERROR_SYNC: 'La información del aliado tiene conflictos con la sincronización del almacén.',
}

export default ABSENCE_REASON_MESSAGES
